import OPTIONS from './settingOptions'

export const TEMPLATES = {
    ACS: {
        displays: {
            authors: true,
            title: false,
            journal: true,
            year: true,
            volume: true,
            page: true
        },
        abbrevs: {
            familyName: false,
            givenName: true,
            journal: true,
        },
        styles: {
            authors: OPTIONS.FONT_STYLE.NORMAL,
            title: OPTIONS.FONT_STYLE.NORMAL,
            journal: OPTIONS.FONT_STYLE.ITALIC,
            year: OPTIONS.FONT_STYLE.BOLD,
            volume: OPTIONS.FONT_STYLE.ITALIC,
            page: OPTIONS.FONT_STYLE.NORMAL,
        },
        conjunctions: {
            betweenFamilyAndGiven: ', ',
            betweenGivenName: ' ',
            betweenAuthors: '; ',
            afterAuthors: ' ',
            afterTitle: '. ',
            afterJournal: ' ',
            afterYear: ', ',
            afterVolume: ', ',
            afterPage: '. ',
        },
        positions: {
            authors: 1,
            title: 2,
            journal: 3,
            year: 4,
            volume: 5,
            page: 6
        },
        misc: {
            givenBeforeFamily: 0,
            etalThreshold: 20,
            useAndBetweenLastTwo: false,
            titleStyle: OPTIONS.TITLE_STYLE.CAP_ALL_WORDS
        }
    },
    RSC: {
        displays: {
            authors: true,
            title: false,
            journal: true,
            year: true,
            volume: true,
            page: true
        },
        abbrevs: {
            familyName: false,
            givenName: true,
            journal: true,
        },
        styles: {
            authors: OPTIONS.FONT_STYLE.NORMAL,
            title: OPTIONS.FONT_STYLE.NORMAL,
            journal: OPTIONS.FONT_STYLE.ITALIC,
            year: OPTIONS.FONT_STYLE.NORMAL,
            volume: OPTIONS.FONT_STYLE.BOLD,
            page: OPTIONS.FONT_STYLE.NORMAL,
        },
        conjunctions: {
            betweenFamilyAndGiven: ' ',
            betweenGivenName: ' ',
            betweenAuthors: ', ',
            afterAuthors: ', ',
            afterTitle: '. ',
            afterJournal: ', ',
            afterYear: ', ',
            afterVolume: ', ',
            afterPage: '. ',
        },
        positions: {
            authors: 1,
            title: 2,
            journal: 3,
            year: 4,
            volume: 5,
            page: 6
        },
        misc: {
            givenBeforeFamily: 1,
            etalThreshold: 20,
            useAndBetweenLastTwo: true,
            titleStyle: OPTIONS.TITLE_STYLE.CAP_ALL_WORDS
        }
    },
    WILEY: {
        displays: {
            authors: true,
            title: false,
            journal: true,
            year: true,
            volume: true,
            page: true
        },
        abbrevs: {
            familyName: false,
            givenName: true,
            journal: true,
        },
        styles: {
            authors: OPTIONS.FONT_STYLE.NORMAL,
            title: OPTIONS.FONT_STYLE.NORMAL,
            journal: OPTIONS.FONT_STYLE.ITALIC,
            year: OPTIONS.FONT_STYLE.BOLD,
            volume: OPTIONS.FONT_STYLE.ITALIC,
            page: OPTIONS.FONT_STYLE.NORMAL,
        },
        conjunctions: {
            betweenFamilyAndGiven: ' ',
            betweenGivenName: '-',
            betweenAuthors: ', ',
            afterAuthors: ', ',
            afterTitle: '. ',
            afterJournal: ', ',
            afterYear: ', ',
            afterVolume: ', ',
            afterPage: '. ',
        },
        positions: {
            authors: 1,
            title: 2,
            journal: 3,
            year: 4,
            volume: 5,
            page: 6
        },
        misc: {
            givenBeforeFamily: 1,
            etalThreshold: 20,
            useAndBetweenLastTwo: true,
            titleStyle: OPTIONS.TITLE_STYLE.CAP_ALL_WORDS
        }
    },
    MASTER: {
        displays: {
            authors: true,
            title: true,
            journal: true,
            year: true,
            volume: true,
            page: true
        },
        abbrevs: {
            familyName: false,
            givenName: true,
            journal: true,
        },
        styles: {
            authors: OPTIONS.FONT_STYLE.NORMAL,
            title: OPTIONS.FONT_STYLE.NORMAL,
            journal: OPTIONS.FONT_STYLE.ITALIC,
            year: OPTIONS.FONT_STYLE.BOLD,
            volume: OPTIONS.FONT_STYLE.ITALIC,
            page: OPTIONS.FONT_STYLE.NORMAL,
        },
        conjunctions: {
            betweenFamilyAndGiven: ' ',
            betweenGivenName: ' ',
            betweenAuthors: '; ',
            afterAuthors: ' ',
            afterTitle: '. ',
            afterJournal: ' ',
            afterYear: ', ',
            afterVolume: ', ',
            afterPage: '. ',
        },
        positions: {
            authors: 1,
            title: 2,
            journal: 3,
            year: 4,
            volume: 5,
            page: 6
        },
        misc: {
            givenBeforeFamily: 0,
            etalThreshold: 20,
            useAndBetweenLastTwo: false,
            titleStyle: OPTIONS.TITLE_STYLE.CAP_ALL_WORDS
        }
    },
    CUSTOM: {}
}



// WEBPACK FOOTER //
// ./src/constants/templates.js